import { createContext } from "react";

import type { TPortalType } from "../store/types";

export const PortalType = createContext("book" as TPortalType);
